import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, Typography } from '@mui/material';
import SkeletonLoader from '../loader/SkeletonLoader';

const GiftCardDeliveryOptionCarousel = ({ cardDeliveryTypeOptionsList, isLoading }) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const touchStartX = useRef(null);
    const touchEndX = useRef(null);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchMove = (e) => {
        touchEndX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = () => {
        if (touchStartX.current && touchEndX.current) {
            const diff = touchStartX.current - touchEndX.current;

            if (diff > 50) {
                setCurrentIndex(prev => Math.min(prev + 1, cardDeliveryTypeOptionsList.length - 1));
            } else if (diff < -50) {
                setCurrentIndex(prev => Math.max(prev - 1, 0));
            }
        }
        touchStartX.current = null;
        touchEndX.current = null;
    };

    useEffect(() => {
        setWindowWidth(window.innerWidth);
    }, [windowWidth]);

    return (
        <Box className='delivery-type-carousel-container'>
            <Grid
                container
                component='ul'
                wrap='nowrap'
                className='carousel-track'
                style={{ transform: `translateX(-${currentIndex * (windowWidth - (windowWidth * 0.275))}px)` }} 
                onTouchStart={handleTouchStart}
                onTouchMove={handleTouchMove}
                onTouchEnd={handleTouchEnd}
            >
                {cardDeliveryTypeOptionsList.map(item => (
                    <Grid key={`${item}`} component='li' item xs={12}>
                        <Box
                            className='gift-card-delivery-type-options carousel-item'
                            sx={{ width: (windowWidth - (windowWidth * 0.35)) }}
                        >
                            <SkeletonLoader
                                isLoading={isLoading}
                                skeletonProps={{
                                    animation: 'wave',
                                    variant: 'rectangular',
                                    className: 'skeletonclass',
                                    height: 56
                                }}
                            >
                                <span className='delivery-type-options-icon'>
                                    {item.icon}
                                </span>
                                <Typography className='delivery-type-options-text'>
                                    {item.text}
                                </Typography>
                            </SkeletonLoader>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
};

GiftCardDeliveryOptionCarousel.propTypes = {
    cardDeliveryTypeOptionsList: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired
};

export default GiftCardDeliveryOptionCarousel;
